import {
  FrequencyUnit,
  Timestamp,
  UpcomingPeriod,
  UpcomingPeriodTypes,
} from '@griply/types';
import { getDaysInMonth, getDaysInYear } from 'date-fns';

import { getSlotVariants, SlotVariant } from './get-slot-variants';

/**
 * Whether the "add occurrence" action (button or menu) should be visible for
 * this period. False when the period is overdue or when every day of the
 * period already has an entry.
 */
export const isAddOccurrenceVisible = (period: UpcomingPeriod): boolean => {
  if (period.type === UpcomingPeriodTypes.Overdue) {
    return false;
  }

  const maxDays =
    period.type === FrequencyUnit.Month
      ? getDaysInMonth(period.date)
      : period.type === FrequencyUnit.Year
        ? getDaysInYear(period.date)
        : 7;

  return period.days.length < maxDays || period.days.some((day) => !day.entry);
};

/**
 * True when at least one day in the period would render the "Repeat until
 * completed" placeholder row (i.e. a generated-frequency entry with no state).
 * Callers use this to label the add-button differently — mobile picks
 * "Plan specific days" when true, otherwise "Plan extra repetition".
 */
export const hasUntilCompletedDay = (
  period: UpcomingPeriod,
  today: Timestamp,
): boolean =>
  period.days.some(({ date, entry }) =>
    getSlotVariants(entry, date, today).includes(SlotVariant.UntilCompleted),
  );
